import React from 'react'
import icon_notice from '../../assets/images/icon_notice.gif'
import spining_gif from '../../assets/images/spining_gif.gif'
import { useNavigate } from 'react-router-dom';

const NoticeList = ({ listData }) => {
  const navigate = useNavigate();

  const handleNoticeClick = (id) => {
    navigate(`/single-notice/${id}`);
  };

  return (
    <>
      <div className='mb-7 p-2.5 lg:p-0 bg-charcoal lg:bg-transparent border border-slate lg:border-none'>
        <table width="100%" border="0" cellpadding="0" cellspacing="0" className='font-NotoSansKR hidden lg:table'>
          <tbody>
            <tr align="center" >
              <th width="70" height="24" className='bg-graphite h-[33px] text-center font-medium text-[13px] text-white border-t-steel border-b-graphite border-t-2 border-b'>번호</th>
              <th className='bg-graphite h-[33px] text-center font-medium text-[13px] text-white border-t-steel border-b-graphite border-t-2 border-b'>제목</th>
              <th width="126" align="left" className='bg-graphite h-[33px] text-center font-medium text-[13px] text-white border-t-steel border-b-graphite border-t-2 border-b' >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;작성자</th>
              <th width="110" className='bg-graphite h-[33px] text-center font-medium text-[13px] text-white border-t-steel border-b-graphite border-t-2 border-b' >작성일시</th>
            </tr>
          </tbody>
        </table>
        <table width="100%" border="0" cellpadding="0" cellspacing="0" className="text-xs text-white font-Time">
          <tbody>
            {listData.map((item, index) => (
              <tr className="bg-graphite lg:bg-transparent" key={index}>
                <td width="70" height="30" align="center" className="h-[36px] border-b border-slate hidden lg:table-cell">
                  <img src={icon_notice} loading='lazy' className='' />
                </td>
                <td className="h-[36px] border-b border-slate ps-[5px] lg:ps-0" >
                  <a href={`/notice/single-notice/${item.id}`} className='text-white lg:text-[#E40003]'><span className='text-gold'>※</span> {item.title} <span className='text-gold'>※</span></a><span className="num_style"></span>
                </td>
                <td width="126" className="h-[36px] border-b border-slate hidden lg:table-cell">
                  <img src={spining_gif} align="absmiddle" className='w-[24px] inline-block me-1' />
                  {item.author}
                </td>
                <td width="110" align="center" className="h-[36px] border-b border-slate hidden lg:table-cell">{new Date(item.created_at).toISOString().split('T')[0]}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

    </>
  )
}

export default NoticeList